// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { IntakeMedicationListResponse } from './intake-medication-list-response';

/** See com.rev360.pms.api.controller.prescription.IntakeMedicationResponse */
/* istanbul ignore next */
@GandalfModel
export class IntakeMedicationResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	dateReported!: Date | null;

	@GandalfProperty({ designType: Number })
	intakeId!: number | null;

	@GandalfArray(IntakeMedicationListResponse)
	intakeMedications!: IntakeMedicationListResponse[] | null;

	@GandalfConstantDecorator(constants.IntakeReconciledStatus)
	@GandalfProperty({ designType: constants.IntakeReconciledStatus })
	medicationCommentsReconciledStatus!: constants.IntakeReconciledStatus | null;

	@GandalfProperty({ designType: Boolean })
	noKnownMedications!: boolean | null;

	@GandalfConstantDecorator(constants.IntakeReconciledStatus)
	@GandalfProperty({ designType: constants.IntakeReconciledStatus })
	noKnownMedicationsReconciledStatus!: constants.IntakeReconciledStatus | null;

}
